module.exports = __webpack_public_path__ + "img/P150T_weapon_98.662cf79f.png";